import { createApi } from "@reduxjs/toolkit/query/react";
import { AUTH, HttpMethod } from "../../data/constants";
import { LoginData, LoginResponse } from "../../data/interfaces";
import { createBaseQuery } from "../helpers/baseQueryHelper";

const authApi = createApi({
  reducerPath: AUTH.reducerPath,
  baseQuery: createBaseQuery(AUTH.baseUrl),
  tagTypes: AUTH.tagTypes,
  endpoints(builder) {
    return {
      login: builder.mutation<LoginResponse, LoginData>({
        query: (restaurantData) => ({
          url: "/restaurant/login",
          method: HttpMethod.POST,
          body: restaurantData,
        }),
      }),
    };
  },
});

export const { useLoginMutation } = authApi;

export { authApi };
